import { Button } from '@mui/material';
import { DataSheetHandler, emptyDataSheet, labelEditorSlice } from 'cdx-common';
import React from 'react';
import { appStore } from 'store';

export const XLSXImporter = () => {

    const handleFile = (content: string | ArrayBuffer, fileName: string) => {

        const datasheet = new DataSheetHandler();
        const result = datasheet.parse(content, fileName);
        if (result) {
            appStore.dispatch(labelEditorSlice.actions.setDataSheet({ ...result }));
        }

    };

    const inputRef = React.useRef<HTMLInputElement>(null);

    const readFile = (files: Blob, fileName: string) => {
        var reader = new FileReader();
        reader.onload = (e) => {
            if (e && e.target && e.target.result) {
                handleFile(e.target.result, fileName);
            }
        };
        reader.readAsArrayBuffer(files);
    };

    const handleChange = (e: any) => {
        e.preventDefault();
        if (e.target.files && e.target.files[0]) {
            readFile(e.target.files[0], e.target?.files?.[0]?.name ?? '');
        }
    };

    return <form onSubmit={(e) => e.preventDefault()}>
        <Button
            sx={{ m: 1 }}
            variant="contained"
            component="label"
        >
            Téléverser un fichier excel
            <input
                ref={inputRef}
                type="file"
                multiple={false}
                onChange={handleChange}
                hidden
            />
        </Button>
        <Button sx={{ m: 1 }} variant="contained" onClick={() => {
            appStore.dispatch(labelEditorSlice.actions.setDataSheet({ ...emptyDataSheet }));
        }}>Feuille vide</Button>
    </form>;
};
